import React from 'react';
import {
  MessageBar,
  makeStyles,
  tokens
} from '@fluentui/react-components';
import { SaveResult } from '../../types/email.types';

interface SaveStatusProps {
  result: SaveResult;
}

const useStyles = makeStyles({
  status: {
    marginTop: tokens.spacingVerticalM,
  }
});

export const SaveStatus: React.FC<SaveStatusProps> = ({ result }) => {
  const styles = useStyles();

  return (
    <MessageBar
      intent="success"
      className={styles.status}
    >
      Email saved successfully! File: {result.filename}
    </MessageBar>
  );
};

export default SaveStatus;
